import { FC } from "react";
import { Button, Modal } from "antd";
import "./modalCustom.scss";
import { noop } from "lodash";

interface ModalCustomProps {
  title: string;
  visible: boolean;
  width?: number;
  zIndex?: number;
  text: string;
  onOk: () => void;
  setVisible: (x: boolean) => void;
  preLine?: boolean;
  showCloseBtn?: boolean;
  reverseButtonDisplayOrder?: boolean;
  okText?: string;
  cancelText?: string;
  customCancelButtonStyle?: {};
  customOkButtonStyle?: {};
  customTextStyle?: {}
}

export function GenericModal({open = false, handleOk = noop, handleCancel = noop , children = <></> , okText='Save' , width = '26rem' , title = '' , okButtonProps = { disabled: '' }} : any) {
  return (
    <Modal title={title} open={open} onOk={handleOk} onCancel={handleCancel} okText={okText} width={width} okButtonProps={okButtonProps}>
        {children}
    </Modal>
  )
}

const ModalCustom: FC<ModalCustomProps> = ({
  title,
  visible,
  setVisible,
  width,
  zIndex,
  onOk,
  text,
  preLine = false,
  showCloseBtn = true,
  reverseButtonDisplayOrder = false,
  okText = "",
  cancelText = "",
  customOkButtonStyle = {},
  customCancelButtonStyle = {},
  customTextStyle = {}
}) => {
  return (
    <>
      <Modal wrapClassName="custom-action-modal" title={title} centered open={visible} footer={false}>
        <>
          <p
            style={{
              fontSize: "14px",
              fontWeight: "normal",
              color: "#091e42",
              whiteSpace: preLine ? "pre-line" : "normal",
            }}
          >
            <span style={{...customTextStyle}}>{text}</span>
          </p>
          <p>
            <div style={{ display: "flex", justifyContent: "center", flexDirection: reverseButtonDisplayOrder ? "row-reverse" : "row" }}>
              {showCloseBtn && (
                <Button size="large" className="f16 w500 close-button" style={{ ...customCancelButtonStyle }} onClick={() => setVisible(false)}>
                  {cancelText === "" ? "Close" : cancelText}
                </Button>
              )}
              <Button type="primary" size="large" className="f16 w500 confirm-button" style={{ ...customOkButtonStyle }} onClick={() => onOk()}>
                {okText === "" ? "Ok" : okText}
              </Button>
            </div>
          </p>
        </>
      </Modal>
    </>
  );
};

export default ModalCustom;
